// Shared configuration utilities for Supabase and GraphQL clients
// This prevents circular dependencies and unwanted module-level execution

// Hardcoded values that match the supabase client configuration
const SUPABASE_URL = "https://qulnbyjrczvoxemtrili.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF1bG5ieWpyY3p2b3hlbXRyaWxpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY1NTYxMzYsImV4cCI6MjA1MjEzMjEzNn0.Rinzz2_HBzxalwRnWVJheDpLC4ghoBEBweweTiwf1eI";

// Determine the Supabase URL from the environment or use a default
export const getSupabaseUrl = (): string => {
  // Try to get from environment variables
  if (typeof process !== 'undefined' && process.env && process.env.REACT_APP_SUPABASE_URL) {
    return process.env.REACT_APP_SUPABASE_URL;
  }

  // Check if there's a global variable set for this
  if (typeof window !== 'undefined' && (window as any).SUPABASE_URL) {
    return (window as any).SUPABASE_URL;
  }

  // Fall back to a default or infer from current location
  if (typeof window !== 'undefined') {
    // If running on a Supabase hosted app, infer from the hostname
    const hostname = window.location.hostname;
    if (hostname.includes('supabase')) {
      return `https://${hostname}`;
    }
  }

  // Use the hardcoded production URL
  return SUPABASE_URL;
};

// Create a function to get the API key in a browser-safe way
export const getApiKey = (): string => {
  // Check for window global variable first
  if (typeof window !== 'undefined' && window.ENV && window.ENV.SUPABASE_ANON_KEY) {
    return window.ENV.SUPABASE_ANON_KEY;
  }
  // Try Next.js public environment variable (will be injected during build)
  if (typeof process !== 'undefined' && process.env && process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY) {
    return process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;
  }
  // Fall back to the hardcoded publishable key
  return SUPABASE_PUBLISHABLE_KEY;
};

// Add type declaration for window.ENV
declare global {
  interface Window {
    ENV?: {
      SUPABASE_ANON_KEY?: string;
      SUPABASE_URL?: string;
    };
  }
}